import { FC } from "react";
import SystemEventsSearchFiltersForm from "./SystemEventsSearchFiltersForm";
import { FormikProps } from "formik";
import { SelectValue } from "../../../types/SelectProps";
import { PaginationEnum } from "../../../domain/enums/common/PaginationEnum";
import { enumToSelectProps, enumValueToSelectProps } from "../../../tools/EnumTools";
import { useTranslation } from "react-i18next";
import { SystemEventsSearchFiltersDTO } from "../../../validation-schemas/SystemEventsSearchFiltersFields";
import CustomDropdown from "../../../custom-components/form-inputs/CustomDropdown";
import FilterResetIconSVG from "../../shared/svg/FilterResetIconSVG";

interface SystemEventsHeaderProps {
    searchFiltersForm: FormikProps<SystemEventsSearchFiltersDTO>;
    filtersFields: SystemEventsSearchFiltersDTO;
    limitHandler: (value: SelectValue) => void;
    resetFiltersHandler: () => void;
    currentLimit: number;
}

const SystemEventsHeader: FC<SystemEventsHeaderProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className="bg-light-bg-100 dark:bg-dark-bg-100 w-[95%] mb-[10px] mt-[10px] mx-auto py-2 px-3 flex items-center justify-between shadow-md rounded-xl">
            <h2 className="text-[20px] font-bold text-light-text-100 dark:text-dark-text-100 ml-4">
                {t("console.sidebar.systemEventsPage")}
            </h2>
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <h3 className="text-[16px] font-semibold text-light-text-100 dark:text-dark-text-100">
                    {t("pagination.show")}
                </h3>
                <CustomDropdown
                    defaultValue={enumValueToSelectProps(props.currentLimit, "pagination")}
                    data={enumToSelectProps(PaginationEnum, "pagination")}
                    dropDownCallback={props.limitHandler}
                    dropdownClassName="w-[80px]"
                />
            </div>
                <SystemEventsSearchFiltersForm form={props.searchFiltersForm} filtersFields={props.filtersFields} />
                <button
                    className="flex items-center text-white bg-light-bg-500 dark:bg-dark-bg-500 hover:bg-light-bg-600 dark:hover:bg-dark-bg-600 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2.5 text-center h-10"
                    onClick={props.resetFiltersHandler}
                    title={t("console.common.resetFilters")}
                >
                    <FilterResetIconSVG className="w-[20px] fill-white" />
                </button>
            </div>
        </div>
    );
};

export default SystemEventsHeader;
